var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import '@mdxeditor/editor/style.css';
import '@/styles/Common/MarkdownEditor.less';
import { BlockTypeSelect, BoldItalicUnderlineToggles, headingsPlugin, listsPlugin, ListsToggle, markdownShortcutPlugin, MDXEditor, Separator, toolbarPlugin, UndoRedo, } from '@mdxeditor/editor';
import { useEffect } from 'react';
const MarkdownEditor = (props) => {
    const { onBlur } = props, restProps = __rest(props, ["onBlur"]);
    // Закрыть редактор при клике вне его
    useEffect(() => {
        const handleClick = (e) => {
            const target = e.target;
            if (target.closest('.editor-save-btn'))
                return;
            if (!target.closest('.mdx-editor') &&
                !target.closest('.mdxeditor-popup-container') &&
                !target.closest('.edit-notes-btn')) {
                onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
            }
        };
        document.addEventListener('mousedown', handleClick);
        return () => document.removeEventListener('mousedown', handleClick);
    }, [onBlur]);
    return (_jsx(MDXEditor, Object.assign({ className: "mdx-editor", contentEditableClassName: "mdx-editor-content", plugins: [
            headingsPlugin(),
            listsPlugin(),
            markdownShortcutPlugin(),
            toolbarPlugin({
                toolbarClassName: 'mdx-editor-toolbar',
                toolbarContents: () => (_jsxs(_Fragment, { children: [_jsx(BlockTypeSelect, {}), _jsx(Separator, {}), _jsx(BoldItalicUnderlineToggles, { options: ['Bold', 'Italic'] }), _jsx(Separator, {}), _jsx(ListsToggle, {}), _jsx(Separator, {}), _jsx(UndoRedo, {})] })),
            }),
        ] }, restProps)));
};
export default MarkdownEditor;
